<template>
    <div class="widgets">
        <div class="intro-widgets">
            <div
                v-for="component in introWidgets"
                :key="component"
                class="widget-wrap"
            >
                <components
                    :is="component"
                    v-if="hasComponent(component)"
                />
            </div>
        </div>
        <div class="widget-columns">
            <div
                v-for="(column, i) in widgets"
                :key="`column-${i}`"
                class="column"
            >
                <div
                    v-for="(widget, n) in column"
                    :key="`widget-${n}`"
                    class="widget-wrap"
                >
                    <components
                        :is="widget.component"
                        v-if="hasComponent(widget.component)"
                        :is-onboarding-complete="isOnboardingComplete"
                        :has-pro-shows="hasProShows"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { has, pickBy } from 'lodash';
import { mapState } from 'vuex';
import * as widgets from './Widgets';

export default {
    components: {
        ...widgets,
    },

    computed: {
        ...mapState({
            shows: ({ shows }) => (shows && Object.values(shows)) || undefined,
            isOnboardingComplete: state => !! state.user?.meta_data?.onboarding_finished,
        }),

        /**
         * @returns {boolean} Whethere or not there are hosted shows.
         */
        hasHostedShow() {
            return !! (this.shows?.find(({ hosted }) => hosted));
        },

        /**
         * @returns {boolean} Whethere or not there are pro shows.
         */
        hasProShows() {
            return !! (this.shows?.find(({ plan }) => ! plan.isFree));
        },

        /**
         * @returns {boolean} Whethere or not user has only free shows.
         */
        hasOnlyFreeShows() {
            return !! (this.shows?.length && this.shows?.every(({ plan }) => plan.isFree));
        },

        /**
         * @returns {object} Sorted widgets.
         */
        widgets() {
            return this.$store.getters.sortedHomeWidgets;
        },

        /**
         * Returns intro widgets components list.
         *
         * @returns {object} Intro widets list.
         */
        introWidgets() {
            return Object.keys(pickBy({
                HostingWidget: this.hasOnlyFreeShows,
                // WelcomeWidget: ! this.hasOnlyFreeShows &&
                //     this.shows &&
                //     ! this.isOnboardingComplete,
                AnalyticsWidget: this.hasHostedShow,
            }));
        },
    },

    methods: {
        /**
         * Checks If the component is registered.
         *
         * @param {string} component Component name.
         * @returns {boolean} Whether the component is registered or not.
         */
        hasComponent(component) {
            return has(this.$options.components, component);
        },
    },
};
</script>
